(function () {
  'use strict';

  d3.chart('ChartBase').extend('Inspector', {
    initialize : function (options) {
      var plot = this;
      options = options || {};

      plot.focus = options.focus;
      if (!plot.focus || !plot.focus.describeDatumUnder) {
        throw new Error('Inspector requires a focus option');
      }

      plot.g = plot.wrap.append('g').classed('inspector', true);

      plot.line = plot.g.append('line')
          .classed('vertical-bar', true);

      plot.layer('data', plot.g.append('g').classed('inspector-bar', true), {
        dataBind : function (data) {
          return this.selectAll('.datum')
              .data(data.y);
        },
        insert : function () {
          return this.insert('circle')
              .classed('datum', true)
              .attr('r', 4);
        },
        events : {
          merge : function () {
            this.attr('cy', _.identity);
          }
        }
      });

      var TIP_MARGIN = 10;
      var tipGroup = plot.g.append('g')
          .classed('tip-wrap', true)
          .translate(TIP_MARGIN, 0);
      var tipBox = tipGroup.append('rect')
          .classed('tip-box', true);
      var tip = tipGroup.append('text')
          .classed('tip', true)
          .translate(5, 3);

      plot.layer('tip', tip, {
        dataBind : function (data) {
          return this.selectAll('tspan.tip-row')
              .data(data.text);
        },
        insert : function () {
          return this.insert('tspan')
              .classed('tip-row', true)
              .attr('x', 0)
              .attr('dy', '1.1em')
        },
        events : {
          merge : function () {
            this.html(function (pair) {
              var name = pair[0],
                  value = pair[1];
              return '<tspan class="tip-label">' + name + ': </tspan>' +
                     '<tspan class="tip-value">' + value + '</tspan';
            });
            var bbox = tip.node().getBBox();
            tipBox
                .attr('width', bbox.width + TIP_MARGIN)
                .attr('height', bbox.height + TIP_MARGIN);
          }
        }
      });

      function currentTranslateX(selection) {
        // this.attr('transform') doesn't work during a transition -- hence the d3.select(this.node())
        return d3.transform(d3.select(selection.node()).attr('transform')).translate[0];
      }

      plot.layer('group', tipGroup, {
        dataBind : function (data) {
          return this.data([data]);
        },
        insert : function () {
          return this;
        },
        events : {
          'update:transition' : function () {
            var leftSide = currentTranslateX(plot.g) > plot.focus.w / 2;
            var boxWidth = Number(tipBox.attr('width'));
            var fullWidth = boxWidth + 2 * TIP_MARGIN;

            var currentX = currentTranslateX(this);
            var targetX = leftSide ? -(boxWidth + TIP_MARGIN) : TIP_MARGIN;

            // avoid jittering by scaling the duration by how far it has to go.
            // this makes the transition always move at the same speed
            var remainingPortion = Math.abs(targetX - currentX) / fullWidth;

            if (plot.g.style('display') === 'none') {
              // the inspector was previously hidden -- snap into position
              remainingPortion = 0;
            }

            this.duration(250 * remainingPortion)
                .ease('linear') // this has to be linear for the above math to work
                .attr('transform', 'translate(' + targetX + ', 0)');
          }
        }
      });

      plot.on('change:height', function () {
        plot.line.attr('y2', plot.h);
      });

      plot.svg()
          .on('mousemove', function () {
            plot.check();
          })
          .on('mouseleave', function () {
            plot.g.style('display', 'none');
          });
    },
    check : function () {
      var plot = this;
      var coords = d3.mouse(plot.wrap.node());
      var datum = plot.focus.describeDatumUnder(coords);
      plot.inspect(datum);
    },
    inspect : function (datum) {
      var plot = this;

      if (datum) {
        plot.g.translate(datum.x, 0);
        plot.draw(datum);
      }

      // do this after so the layers know when we're hidden
      plot.g.style('display', datum ? 'initial' : 'none');
    }
  });

})();
